<template>
	<section class="quotes--quote-summary">
		<div class="animated fadeIn purchaseorders--purchaseorders-list h-100">
			<b-row id="purchaseorders-header-nav">
				<b-col cols="4">
					<h1 id="purchaseorders-header-nav-txt">{{ headerObj.pageTitle }}</h1>
				</b-col>
				<b-col cols="2">
					<h2 id="purchaseorders-header-nav-txt">{{ headerObj.contactFullName || '' }}</h2>
				</b-col>
				<b-col cols="2">
					<h2 id="purchaseorders-header-nav-txt">{{ headerObj.dateValue }}</h2>
				</b-col>
				<b-col cols="2">
					<h2 id="purchaseorders-header-nav-txt">{{ headerObj.statusName }}</h2>
				</b-col>
			</b-row>
			<b-card class="card h-30">
				<div class="mt-35">
					<br/>
					<b-tabs class="d-flex flex-column h-100" content-class="flex-one d-flex" active-tab-class="d-flex flex-column w-100">
						<b-tab active title="PO Items">
							<b-row>
								<h6 class="mt-1 mb-1">
									Please select a line to receive
								</h6>
								<purchase-order-lines
									:purchaseOrderId="purchaseOrderId"
									:gridId="lineGridId"
									ref="po-lines-grid"
									isReceiveItemComponent
									@selectedPurchaseOrderLine="onPOLineSelect"
								/>
							</b-row>
						</b-tab>
					</b-tabs>
				</div>
			</b-card>
			<b-card class="h-30" v-if="selectedPoLineId > 0">
				<div class="card-body">
					<h6>Please confirm the part information and click "Receive" to receive the item</h6>
					<br/>
					<b-row>
						<!-- <b-col cols="2">
							<dt>Receiving Line</dt>
							<dd>{{ purchaseOrderLine.id }}</dd>
						</b-col> -->
						<b-col cols="2">
							<dt>Part</dt>
							<dd>{{ purchaseOrderLine.partNumber }}</dd>
						</b-col>
						<b-col cols="2">
							<dt>Ordered</dt>
							<dd>{{ format(purchaseOrderLine.quantity) }}</dd>
						</b-col>
						<b-col cols="2">
							<dt>Remaining</dt>
							<dd>{{ format(remainingQuantityToReceive) }}</dd>
						</b-col>
						<b-col cols="2">
							<dt>Shipping To:</dt>
							<dd>{{ purchaseorder.shippingCompanyName }}</dd>
						</b-col>
						<b-col cols="2" v-if="workOrderId > 0 && isReceiveHasTest">
							<dt>Work Order No</dt>
							<dd>{{ workOrderId }}</dd>
						</b-col>
						<!-- <b-col cols="2" v-if="purchaseorder.isDropShip">
							<dt>Drop Ship to Customer</dt>
							<dd>{{ purchaseOrderLine.customerName }}</dd>
						</b-col> -->
					</b-row>
					<br/>
					<div>
						<receive-details
							:receiveDetailsArr="receiveFormDetailsArr"
							:lineReceiveObj="lineReceiveObj"
							:ncmReportObj="ncmReportObj"
							:purchaseOrderLine="purchaseOrderLine"
							:destAddr="purchaseorder.shippingAddressName"
							@receiveInput="setReceiveDetails"
							@quantityChange="onQuantityChange($event)"
							@onTestChange="checkWorkOrder($event)"
							:isShowReports="isReceivedSuccess"
							:isDropShip="purchaseorder.isDropShip"
						/>
					</div>
				</div>
				<b-row>
					<b-col>
						<div class="buttons-panel" v-if="!isReceivedSuccess || isReceivedPersist">
							<b-button size="sm" variant="outline-danger" class="mr-1" @click="redirectToList">Back to List</b-button>
							<b-button size="sm" class="mr-1" @click="handleClear">Clear</b-button>
							<b-button variant="primary" size="sm" class="mr-1" :disabled="receivingInProcess" @click="onBeforeReceive(false)">
								<i v-if="receivingInProcess" class="fa fa-spinner fa-pulse fa-fw mr-1"></i>
								Receive
							</b-button>
							<b-button v-if="isMultipleLines" variant="primary" size="sm" class="mr-1" :disabled="receivingInProcess" @click="onBeforeReceive(true,1)">
								<i v-if="receivingInProcess" class="fa fa-spinner fa-pulse fa-fw mr-1"></i>
									Receive & Next Line
							</b-button>
							<b-button v-if="isReceiveHasRma" variant="primary" size="sm" class="mr-1" :disabled="receivingInProcess" @click="onBeforeReceive(true,2)">
								<i v-if="receivingInProcess" class="fa fa-spinner fa-pulse fa-fw mr-1"></i>
									Return Rejected Items
							</b-button>
							<b-button v-if="isReceiveHasTest" variant="primary" size="sm" class="mr-1" :disabled="receivingInProcess" @click="onBeforeReceive(true,3)">
								<i v-if="receivingInProcess" class="fa fa-spinner fa-pulse fa-fw mr-1"></i>
									Receive & Go to Work Order
							</b-button>
							<b-button variant="primary" size="sm" :disabled="receivingInProcess" @click="onBeforeReceive(true)" v-if="!isReceiveHasRma && !isMultipleLines">
								<i v-if="receivingInProcess" class="fa fa-spinner fa-pulse fa-fw mr-1"></i>
								Receive & Exit
							</b-button>
						</div>
						<div class="buttons-panel" v-else>
							<b-button size="sm" variant="outline-danger" class="mr-1" @click="redirectToList">Back to List</b-button>
						</div>
					</b-col>
				</b-row>

			</b-card>
			<b-card class="h-30" v-if="selectedPoLineId > 0">
				<b-tabs class="d-flex flex-column h-100" content-class="flex-one d-flex" active-tab-class="d-flex flex-column w-100">
					<b-tab title="Items Received against the Purchase Order Line">
						<inventory-list :purchaseOrderLineId="currentLineId" :gridId="inventoryGridId"  @deletedReceivedItem="onDeleteReceived" hidePostSource hideActions />
					</b-tab>
				</b-tabs>
			</b-card>
			<div v-if="purchaseorder.isDropShip">
				<open-invoices :companyId="purchaseOrderLine.customerId" @invoiceLineSelected="setInvoiceId" isReceivingPO  />
			</div>
			<add-service-order :poLineDetail="purchaseOrderLine" :qtyToTest="qtyTesting" v-if="checkClaim(CAN_ADD_WORK_ORDER)" isReturnId @newWorkOrder="onCreatedWorkOrder($event)" />
		</div>
	</section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import RequirementDetails from '@/shared/components/RequirementDetails/index';
import { date } from '@/shared/filters';
import { GRID_ID } from '@/shared/constants';
import PurchaseOrderLines from '@/pages/PurchaseOrders/components/PurchaseOrderLines';
import InventoryList from '@/shared/components/InventoryList';
import DateRangePicker from '@/shared/components/DateRangePicker';
import ReceiveDetails from '@/shared/components/ReceiveDetails';
import FixedHeader from '@/shared/components/FixedHeader/index';
import OpenInvoices from '@/pages/Invoices/components/add/AddToOpenInvoice';
import AddServiceOrder from '@/pages/PurchaseOrders/components/edit/components/AddServiceOrder';

export default {
	components: {
		RequirementDetails,
		DateRangePicker,
		ReceiveDetails,
		FixedHeader,
		InventoryList,
		PurchaseOrderLines,
		OpenInvoices,
		AddServiceOrder
  },
  metaInfo: () => ({
    title: 'Purchaseorders',
  }),
	data() {
		return {
			date,
			gridId: GRID_ID.PURCHASE_ORDERS,
			lineGridId: GRID_ID.PURCHASE_ORDER_LINES_RECEIVING,
			inventoryGridId: GRID_ID.INVENTORY_RECEIVED,
			selectedRowItemId: 0,
			lineObj: {},
			mergedObj: {},
			rmaObj: {},
			receiveFormDetailsArr: [],
			lineReceiveObj: {},
			ncmReportObj: {},
			onReceiveRMA: false,
			headerObj: {
				pageTitle: 'Receive Item',
				contactFullName: '',
				dateValue: '',
				statusName: ''
			},
			purchaseOrderLine: {},
			onNextItem: false,
			invoiceId: 0,
			isToRedirectVal: false,
			actionVal: 0,
			receivingInProcess: false,
			isReceivedSuccess: false,
			isReceivedPersist: false,
			selectedPoLineId: 0,
			workOrderId: 0,
			qtyTesting: 0
		};
	},
	computed: {
		...mapGetters('purchaseOrderLines', ['purchaseOrderLines']),
		...mapGetters('purchaseorders', ['purchaseorder']),
		...mapGetters('account', ['gridSettingsById', 'userId']),
		...mapGetters('serviceOrderLines', ['serviceOrderLineByPoLine']),
		// ...mapGetters('inventory', ['inventoryListForPOLineId']),
		purchaseOrderId() {
			return parseInt(this.$route.params.purchaseOrderId, 10);
		},
		gridSettings() {
			return this.gridSettingsById(this.gridId);
		},
		sumReceiveQuantity() {
			return this.receiveFormDetailsArr.map(details => details.quantity).reduce((a, b) => a + b);
		},
		isReceiveHasRma() {
			return this.receiveFormDetailsArr.filter(rcv => rcv.rejected == true).length > 0;
		},
		isReceiveHasTest() {
			return this.receiveFormDetailsArr.filter(rcv => rcv.test == true).length > 0;
		},
		isPOLineExist() {
			return Object.keys(this.purchaseOrderLine).length > 0
		},
		isMultipleLines() {
			return (Object.keys(this.purchaseorder).length > 0) ? this.purchaseorder.lineCount > 1 : false;
		},
		currentLineId() {
			return this.purchaseOrderLine.id;
		},
		remainingQuantityToReceive() {
			return (this.purchaseOrderLine.quantity - this.purchaseOrderLine.qtyReceived);
		}
	},
	filters: {
		date,
	},
	methods: {
		...mapActions('purchaseorders', ['getById', 'receivePOLine']),
		...mapActions('account', ['saveGridSettings']),
		...mapActions('serviceOrderLines', { getServiceOrderByPOLineId: 'getByPurchaseOrderLineId'}),
		// ...mapActions('inventory', ['receiveAndSaveToInventory', 'getInventoryFiltered']),
		...mapActions('inventory', ['getInventoryFiltered']),
		...mapActions('address', ['getAddresses']),
		readyMadeReceiveDetailObj() {
			return {
				id: 0,
				quantity: null,
				discrepancy: false,
				rejected: false,
				test: false,
				repack: false,
				cost: (this.isPOLineExist) ? this.purchaseOrderLine.price : 0,
				dateCode: (this.isPOLineExist) ? this.purchaseOrderLine.dateCode : null,
				lotCode: (this.isPOLineExist) ? this.purchaseOrderLine.lotCode : null,
				revision: (this.isPOLineExist) ? this.purchaseOrderLine.revision : null,
				conditionId: (this.isPOLineExist) ? this.purchaseOrderLine.conditionId : 0,
				countryOfOriginId: (this.isPOLineExist) ? this.purchaseOrderLine.countryOfOriginId : 0,
				vrmaReasonId: 0,
				comments: null,
				warehouseId: this.purchaseorder.shippingAddressId,
				location: null,
				isSplit: false,
				inventorySplits: [],
				images: []
			};
		},
		readyMadeNCMReportObj() {
			return {
				id: 0,
				purchaseOrderLineId: (this.isPOLineExist) ? this.purchaseOrderLine.id : 0,
				inspectedByUserId: this.userId,
				dateInspected: new Date(),
				partId: (this.isPOLineExist) ? this.purchaseOrderLine.partId : 0,
				quantity: 0,
				ncmCodeId: 0,
				description: null,
				customerFound: false,
			}
		},
		readyMadeLineReceiveObj() {
			const receive = (this.purchaseOrderLine.quantity - this.purchaseOrderLine.qtyReceived);

			return {
				received: (this.remainingQuantityToReceive > 0) ? this.remainingQuantityToReceive : 0,
				testingRequired: false,
				showDetails: (this.remainingQuantityToReceive > 0)
			}
		},
		async onQuantityChange(val) {
			let received = parseInt(this.lineReceiveObj.received, 10);
			console.log(this.receiveFormDetailsArr[this.receiveFormDetailsArr.length -1].quantity == 0, this.receiveFormDetailsArr[this.receiveFormDetailsArr.length -1].quantity, val, isNaN(val))
			if (this.sumReceiveQuantity < received && this.receiveFormDetailsArr[this.receiveFormDetailsArr.length -1].quantity > 0) {
				this.receiveFormDetailsArr.push(this.readyMadeReceiveDetailObj());
			} else if (this.sumReceiveQuantity === received
				&& (this.receiveFormDetailsArr[this.receiveFormDetailsArr.length -1].quantity == 0 || this.receiveFormDetailsArr[this.receiveFormDetailsArr.length -1].quantity == null)) {
				this.receiveFormDetailsArr.pop();
			} else if ((val == 0 || isNaN(val)) && this.receiveFormDetailsArr[this.receiveFormDetailsArr.length - 1].quantity == null && this.receiveFormDetailsArr.length != 1) {
				this.receiveFormDetailsArr.pop();
			}
		},
		redirectToList() {
			if (this.purchaseOrderId != undefined) {
				this.$router.push({
					name: 'purchaseorders.edit',
					params: { id: this.purchaseOrderId },
				});
			}
		},
		validateReceived(line, isSplit) {
			let isValid = line.quantity != ""
					&& line.cost != ""
					&& line.conditionId != 0
					&& line.countryOfOriginId != 0
			if (line.warehouseId == 0) {
				alert("Invalid Shipping Destination. Please check PO Details");
				return false;
			}

			if (!isSplit) {
				return isValid && line.location != null;
			} else {
				return isValid;
			}
			
		},
		isValidLines(lines) {
			let isValid = true;
			for (let i = 0; i < lines.length; i++) {
				if (lines[i].isSplit) {
					for (let j = 0; j < lines[i].inventorySplits.length; j++) {
						if (!this.validateReceived(lines[i].inventorySplits[j], true)) {
							return false;
						}
					}
				}
				else {
					if (!this.validateReceived(lines[i], false)) {
						return false;
					}
				}
			}

			return isValid;
		},
		async onBeforeReceive(isToRedirect, action = 0) {
			this.isToRedirectVal = isToRedirect;
			this.actionVal = action;

			if (this.purchaseorder.isDropShip && !this.isReceiveHasTest) {
        const confirmation = await this.openConfirmBox({
          message: 'This purchase order is a DROPSHIP. Would you like to create a new invoice or add to an existing invoice?',
          okVariant: 'info',
          okTitle: 'ADD to existing invoice',
          cancelVariant: 'success',
          cancelTitle: 'CREATE a new invoice',
          footerClass: 'p-2',
          hideHeaderClose: false,
        });
        if (confirmation) {
          this.$bvModal.show('add-to-invoice-modal');
        } else {
          this.receiveItemDetails();
        }
			} else if (this.isReceiveHasTest && this.workOrderId == 0) {
				const qty = this.receiveFormDetailsArr.filter(x => x.test == true).map(details => details.quantity).reduce((a, b) => a + b);
				this.checkWorkOrder({ isTest: true, qty: qty });
			} else {
				this.receiveItemDetails();
			}
		},
		async receiveItemDetails() {
			// if (this.lineReceiveObj.received > this.remainingQuantityToReceive) {
			// 	alert("You cannot receive quantity that is greater than the remaining.");
			// 	return;
			// }

			let tempReceiveArr = this.receiveFormDetailsArr;

			// Auto disregards the newly added last row...
			if (tempReceiveArr.length > 1
				&& tempReceiveArr[tempReceiveArr.length -1].quantity == null) {
				tempReceiveArr.pop();
			}

			if (tempReceiveArr.length > 0 && !this.isValidLines(tempReceiveArr)) {
				alert("Please populate required fields.");
				return;
			}
			this.receivingInProcess = true;
			this.$snotify.info('Receiving in progress', 'Receive Purchase Orders Line');

			const receiveData = {
				...this.lineReceiveObj,
				purchaseOrderLineId: this.purchaseOrderLine.id,
				shippingToCompanyId: this.purchaseorder.shippingCompanyId,
				lines: tempReceiveArr,
				invoiceId: this.invoiceId,
				workOrderId: this.workOrderId,
				images: tempReceiveArr.map(x => x.images)
			}

			var formData = new FormData();

			for (var key in receiveData) {
				if (key == 'lines' && tempReceiveArr.length > 0) {
					receiveData[key].forEach(element => {
						formData.append('linesInString[]', JSON.stringify(element));
					});

				} else if (key == 'images' && receiveData[key].length > 0) {
					receiveData[key].forEach(element => {
						for (var el in element) {
							console.log('element', el, element, new Blob(element, {type: element.type}))
							formData.append('files[]', element[el], element[el].name);
						}

					});
				} else {
					formData.append(key, receiveData[key]);
				}
			}

			const result = await this.receivePOLine(formData);
			this.receivingInProcess = false;
			if (result.status == 200) {
				this.$snotify.success('Receiving Saved', 'Receive Purchase Orders Line');
				this.getItemsReceivedForPoLine();
				const quantitySum = tempReceiveArr.map(details => parseInt(details.quantity)).reduce((a, b) => a + b);
				this.purchaseOrderLine.qtyReceived += quantitySum;
				if (this.purchaseOrderLine.qtyReceived >= this.purchaseOrderLine.quantity) {
					this.purchaseOrderLine.statusId = 160;
					this.purchaseOrderLine.statusName = 'Received';
					this.isReceivedSuccess = true;

					if (this.purchaseOrderLines.length == this.purchaseOrderLines.filter(x => x.statusId == 160).length) {
						this.headerObj.statusName = 'Received';
					}
				} else if (this.purchaseOrderLine.qtyReceived > 0 && this.purchaseOrderLine.qtyReceived < this.purchaseOrderLine.quantity) {
					this.purchaseOrderLine.statusId = 158;
					this.purchaseOrderLine.statusName = 'Partially Received';
				}


				this.setLineReceiveObject();
			}

			if (this.actionVal == 0 && this.isToRedirectVal) {
				this.redirectToList();
			} else if (this.actionVal != 0) {
				switch(this.actionVal) {
					case 1:
						let poCurrentIndex = this.purchaseOrderLines.findIndex(x => x.id == this.purchaseOrderLine.id);
						let poLinesCount = this.purchaseOrderLines.length - 1;
						this.onNextItem = true;
						this.$refs['po-lines-grid'].selectedRowItemId = (poCurrentIndex + 1 <= poLinesCount)
						? this.purchaseOrderLines[poCurrentIndex + 1].id : this.purchaseOrderLines[0].id;
						break;
					case 2:
						for (let i = 0; i < result.data.vendorRmaIds.length; i++)
						{
							let routeData = this.$router.resolve({
								name: 'vendorrmas.edit',
								params: { id: result.data.vendorRmaIds[i] },
							});
							window.open(routeData.href, '_blank');
						}
						break;
					case 3:
						this.$router.push({
							name: 'serviceorders.edit',
							params: { id: this.workOrderId },
						});
						break;
				}
			}
		},
		handleClear() {
			this.receiveFormDetailsArr = [];
			this.setNcmReportObject();
			this.setLineReceiveObject();
			this.isReceivedSuccess = (this.remainingQuantityToReceive <= 0);
		},
		async setReceiveDetails() {
			this.receiveFormDetailsArr = [];
			let receiveLocal = true;

			if (this.lineReceiveObj.received > this.remainingQuantityToReceive) {
        this.isReceivedPersist = receiveLocal = await this.openConfirmBox({message: `You are attempting to receive more items than you have been ordered. Are you certain you wish to continue?`});
			}

			if (this.isPOLineExist && this.lineReceiveObj.received > 0 && receiveLocal) {
				let receiveDetailObj = this.readyMadeReceiveDetailObj();

				receiveDetailObj.quantity = this.lineReceiveObj.received;

				this.receiveFormDetailsArr.push(receiveDetailObj);
				this.lineReceiveObj.showDetails = true;
			} else {
				this.lineReceiveObj.showDetails = false;
			}
		},
		setNcmReportObject() {
			this.ncmReportObj = this.readyMadeNCMReportObj();
		},
		setLineReceiveObject() {
			this.lineReceiveObj = this.readyMadeLineReceiveObj();
			if (this.remainingQuantityToReceive > 0) {
				this.setReceiveDetails();
			}
		},
		setData(poLine) {
			this.purchaseOrderLine = poLine;
			this.isReceivedSuccess = (this.remainingQuantityToReceive <= 0);
			this.setNcmReportObject();
			this.setLineReceiveObject();
		},
		async onPOLineSelect($event) {
			this.selectedPoLineId = $event.id;
			this.workOrderId = 0;


			if (this.currentLineId == undefined) {
				this.setData($event);
			} else if (this.currentLineId != $event.id && this.isReceiveItemHasChanges()) {
				if (this.onNextItem) {
					this.onNextItem = false;
					this.setData($event);
				} else {
          const deleteConfirmed = await this.openConfirmBox({message: 'Are you sure you want to abandon this current receive Purchase Orders line item?'});
          if (deleteConfirmed) {
            this.setData($event);
          }else {
            this.$refs['po-lines-grid'].selectedRowItemId = this.currentLineId;
          }
				}
			} else if (this.currentLineId != $event.id || Object.keys(this.lineReceiveObj).length == 0) {
				this.setData($event);
			}


			if (!this.purchaseorder.isDropShip) {
				// get the service order by the selected po line
				if (Object.keys(this.serviceOrderLineByPoLine).length == 0 || this.serviceOrderLineByPoLine[0].purchaseOrderLineId != $event.id) {
					await this.getServiceOrderByPOLineId($event.id);
				}

				if (Object.keys(this.serviceOrderLineByPoLine).length > 0) {
					this.workOrderId = this.serviceOrderLineByPoLine[0].serviceOrderId;
					this.getAddresses(this.serviceOrderLineByPoLine[0].testHouseId);

					if (this.workOrderId > 0 && this.isPOLineExist && Object.keys(this.lineReceiveObj).length > 0) {
						console.log('Game', this.remainingQuantityToReceive, this.receiveFormDetailsArr.length)
						this.lineReceiveObj = { ...this.lineReceiveObj, testingRequired: true };
						if (this.remainingQuantityToReceive > 0 && this.receiveFormDetailsArr.length > 0) {
							for(let i = 0; i < this.receiveFormDetailsArr.length; i++) {
								this.receiveFormDetailsArr[i].test = true;
								this.receiveFormDetailsArr[i].location = null;
								this.receiveFormDetailsArr[i].rejected = false;
								this.receiveFormDetailsArr[i].discrepancy = false;
							}
						}
					}
				}
			} else if (this.purchaseorder.isDropShip && $event.customerId) {
				this.getAddresses($event.customerId);
			}
		},
		isReceiveItemHasChanges() {
			return JSON.stringify(this.lineReceiveObj) !== JSON.stringify(this.readyMadeLineReceiveObj())
			|| this.receiveFormDetailsArr.length > 1;
		},
		async getItemsReceivedForPoLine() {
			await this.getInventoryFiltered({
				purchaseOrderLineId: this.currentLineId
			});
		},
		setInvoiceId(id) {
			this.invoiceId = id;
			this.receiveItemDetails();
		},
		onDeleteReceived(qtyDeleted) {
			this.purchaseOrderLine.qtyReceived -= qtyDeleted;
			if (this.purchaseOrderLine.statusId == 160) {
				this.purchaseOrderLine.statusId = 159;
				this.purchaseOrderLine.statusName = 'On Order';
				this.headerObj.statusName = 'Pending';
				this.isReceivedSuccess = (this.remainingQuantityToReceive <= 0);
				this.setNcmReportObject();
				this.setLineReceiveObject();
			}

			// this.lineReceiveObj.received = 0;
			// this.lineReceiveObj.showDetails = false;
		},

    format(val) {
      try {
        var str = Number(val || 0).toString().split('.');
        if (str[0].length >= 3) {
          str[0] = str[0].replace(/(\d)(?=(\d{3})+$)/g, '$1,');
        }
        if (str[1]) {
          if (str[1].length < 2) {
            while (str[1].length < 2) { str[1] = str[1] + "0"; }
          } else if (str[1].length > 2) {
            str[1] = str[1].substring(0, 2)
          }
        }
        return str.join('.');
      } catch {
        return val;
      }
		},
		async checkWorkOrder({isTest, qty}) {
			if (isTest && this.workOrderId == 0) {
				const confirmation = await this.openConfirmBox({
          message: 'This purchase order line doesnt have work order associated. Proceed to create a work order?',
          footerClass: 'p-2',
          hideHeaderClose: false,
        });
        if (confirmation) {
					this.qtyTesting = qty;
          this.$bvModal.show('add-service-order-modal');
        }
			}
		},
		onCreatedWorkOrder(val) {
			if (val != null) {
				this.workOrderId = val.id;
				this.getAddresses(val.companyId);
			}
		}
	},
	async mounted() {
		if (this.purchaseOrderId != undefined) {
			await this.getById(this.purchaseOrderId).then(() => {
				this.headerObj.pageTitle = 'RECEIVING Purchase Orders ' + this.purchaseorder.id + ' - ' + this.purchaseorder.companyName;
				this.headerObj.contactFullName = 'Contact: ' + (this.purchaseorder.contactFullName || ''); //empty condition added by jitendra becasue when contact name is empty then it shows null
				this.headerObj.dateValue = 'Purchase Order Date: ' + date(this.purchaseorder.poDate);
				this.headerObj.statusName = 'Status: ' + this.purchaseorder.statusName;
			});
		}

		// if (this.$route.params.purchaseOrderLineId != undefined && this.purchaseorder.lines.length > 0) {
		// 	this.purchaseOrderLine = this.purchaseorder.lines.find(x => x.id == this.$route.params.purchaseOrderLineId);
		// }
	},
	beforeDestroy() {

	},
};
</script>

<style lang="scss">
@import '@/assets/scss/_colors.scss';

#purchaseorders-header-nav {
    width: 100%;
    z-index: 1000;
    position: fixed;
    border-bottom: 1px solid rgb(200, 206, 211);
    background: #fff;
}

#purchaseorders-header-nav-txt {
  background-color: #fff;
  padding: 8px;
  font-size: 20px;
  margin: 0px;
}

.buttons-panel {
    margin-top: 20px;
    text-align: right;

    .btn {
      margin-left: 10px;
    }
  }


.purchaseorders {
  &--purchaseorders-list {
    .tools > * {
      margin: 0 0 0 3px;
    }
    .b-pagination {
      justify-content: center;
    }
    .create-ultra-rfp {
      margin-top: 0.5em;
      margin-bottom: 1em;
    }
    table td {
      cursor: pointer;
    }
    .buttons-panel {
      text-align: right;
      margin-right: 30px;
      margin-top: 7px;
      .btn {
        margin-left: 5px;
      }

    }
    .clear-filter-button-container {
      margin-top: 12px;
      text-align: right;
    }
  }

  &--grid-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}

.highlight {
  background: $rowSelection !important;
}

.b-pagination {
  justify-content: center;
}

.tools > * {
  margin: 0 0 0 3px;
}

.card-body {
	padding: 0.75rem !important;
}

#KendoGrid .k-virtual-scrollable-wrap table {
	min-width: 800px;
}

.required-indicator {
	color: red
}

.mt-15 {
	margin-top: 15px;
}

.mt-35 {
	margin-top: 35px;
}

.mt-50 {
	margin-top: 50px;
}

.medium-font-size {
	font-size: medium;
}

dt { font-size: medium; }
dd { font-size: medium; }
</style>
